<form [formGroup]="formGroup">
  <mat-radio-group class="indent-radio-group" formControlName="area">
    <mat-radio-button [value]="customerArea">{{ 'TOOLBAR.ACCOUNT_AREAS.CUSTOMER' | translate }}</mat-radio-button>
    <mat-radio-button [value]="laboratoryArea">{{ 'TOOLBAR.ACCOUNT_AREAS.LABORATORY' | translate }}</mat-radio-button>
  </mat-radio-group>
</form>
